if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      ProductForm.normalizeAkdShirtQuantityProperty(formData);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        let renderData = data;
        const rushUpgrade = this.form.querySelector('[data-akd-rush-upgrade]');
        const rushVariantId = rushUpgrade?.checked ? rushUpgrade.dataset.variantId : null;
        if (rushVariantId) {
          const rushFormData = new FormData();
          rushFormData.append('id', rushVariantId);
          rushFormData.append('quantity', '1');
          rushFormData.append(
            'properties[_Rush upgrade for]',
            this.form.querySelector('[data-akd-product-title]')?.value || document.title
          );
          rushFormData.append('sections_url', window.location.pathname);
          rushFormData.append('sections', sections);

          const rushResponse = await fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: rushFormData
          });
          const rushData = await rushResponse.json();
          const rushError = typeof rushData.description === 'string' ? rushData.description : rushData.message;
          if (rushData.status) this.setErrorMsgState(rushError);
          if (!rushResponse.ok) throw new Error(rushResponse.status);
          renderData = rushData;
        }

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(renderData);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                renderData,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
         if (!rushVariantId && !!window.easifyHandleUpdateCartWithAddonProduct && typeof window.easifyHandleUpdateCartWithAddonProduct === 'function') {
            setTimeout(async () => {
              await window.easifyHandleUpdateCartWithAddonProduct();
              await window.easifyHandleCalculateCart();
            }, 1000)
          }

      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    static normalizeAkdShirtQuantityProperty(formData) {
      const propertyName = 'properties[Shirt Quantity]';
      const value = formData.get(propertyName);
      if (!value) return;

      const rows = ProductForm.parseAkdShirtQty(value);
      if (!rows.length) return;

      formData.set(propertyName, rows.map((row) => `${row.size} ${row.qty}`).join('\n'));
    }

    static parseAkdShirtQty(value) {
      const rawSource = String(value || '').replace(/\r\n/g, '\n').trim();
      const source = rawSource.replace(/\s+/g, ' ').trim();
      if (!source) return [];

      const formattedRows = [];
      source.replace(/([A-Za-z0-9]+)\s*-\s*Qty\s*(\d+)\s*\[\s*([^\]]+)\s*\]/g, (match, size, qty, cost) => {
        formattedRows.push({ size, qty, cost });
        return match;
      });

      if (formattedRows.length) return formattedRows;

      const rows = [];
      let currentRow = null;
      rawSource.split(/\s*\|\s*|\s*,\s*|\n+/).map((part) => part.trim()).filter(Boolean).forEach((part) => {
        const match = part.match(/^(?:(\d+)\s*,\s*)?([A-Za-z0-9]+)\s*(?:-\s*Qty\s*(\d+))?\s*\[\s*\+?([^\]]+)\s*\](?:\s*\[\s*\+?([^\]]+)\s*\])?(?:\s*(\d+))?$/);
        if (match) {
          if (match[1] && currentRow && !currentRow.qty) currentRow.qty = match[1];

          currentRow = {
            size: match[2],
            qty: match[3] || match[6] || '',
            cost: match[5] || match[4]
          };
          rows.push(currentRow);
          return;
        }

        if (/^\d+$/.test(part) && currentRow && !currentRow.qty) {
          currentRow.qty = part;
        }

        const repeatedCompactMatch = part.match(/^([A-Za-z]+)(\d+)\2$/);
        if (repeatedCompactMatch) {
          currentRow = {
            size: repeatedCompactMatch[1],
            qty: repeatedCompactMatch[2],
            cost: ''
          };
          rows.push(currentRow);
          return;
        }

        const simpleMatch = part.match(/^([A-Za-z0-9]+)(?:\s+-\s*Qty\s*|\s+)(\d+)$/);
        if (simpleMatch) {
          currentRow = {
            size: simpleMatch[1],
            qty: simpleMatch[2],
            cost: ''
          };
          rows.push(currentRow);
          return;
        }

        const compactMatch = part.match(/^([A-Za-z]+)(\d+)$/);
        if (compactMatch) {
          currentRow = {
            size: compactMatch[1],
            qty: compactMatch[2],
            cost: ''
          };
          rows.push(currentRow);
          return;
        }

      });

      const filteredRows = rows.filter((row) => row.size && row.qty);
      if (filteredRows.length === 1 && filteredRows[0].qty === '0') filteredRows[0].qty = '100';
      return filteredRows;
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
